import { SP4_TOPICS } from "./levels/sp4";
import { SP5_TOPICS } from "./levels/sp5";
import { SP6_TOPICS } from "./levels/sp6";
import { SP7_TOPICS } from "./levels/sp7";
import { SP8_TOPICS } from "./levels/sp8";
import { hasTopic, registerTopics } from "./registry";

/** Register every level once (safe to import from many places). */
if (!hasTopic("sp6.integers_ops")) {
  registerTopics([...SP4_TOPICS, ...SP5_TOPICS, ...SP6_TOPICS, ...SP7_TOPICS, ...SP8_TOPICS]);
}

export * from "./types";
export { createRng, randomSeed } from "./rng";
export {
  allTopics,
  defaultPreference,
  generateQuestion,
  getTopic,
  hasTopic,
  topicsForLevel,
} from "./registry";
export { checkAnswer, normalizeInput, normalizeText, parseFraction, parseNumber } from "./parseAnswer";
export {
  accuracyOf,
  isMastered,
  needsPractice,
  pickTier,
  pickTopic,
  topicWeight,
  updateStat,
} from "./adaptive";
export { clean, numStr } from "./format";
